
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MessageBox';
import { getOrderHistory } from '../features/OrderHistorySlice';

export default function OrderHistoryScreen() {
 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const orderHistory = useSelector((state) => state.orderHistory);
    const { error, orders, status} = orderHistory;

    useEffect(() => {
      dispatch(getOrderHistory());
    },[dispatch]);
    
  return status === "pending" ? (<LoadingBox>Loading...</LoadingBox>)
        : status === "rejected" ? (
        <MessageBox variant="danger">{error}</MessageBox> 
        ) : 
        (
          <table className='table'>
            <thead>
              <tr>
                <th>ID</th>
                <th>DATE</th>
                <th>TOTAL</th>
                <th>PAID</th>
                <th>DELIVERED</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.created_at.substring(0, 10)}</td>
                  <td>{order.total_price}</td>
                  <td>{order.is_paid ? order.paid_at.substring(0, 10) : 'NO'}</td>
                  <td>{order.is_delivered ? order.delivered_at.substring(0, 10) : 'NO'}</td>
                  <td><button type='button' className='small'
                    onClick={() => {navigate(`/order/${order.id}`)}}
                  >Details</button>
                  </td>
                </tr>
              ))}
            </tbody>  
          </table>  
        )
}
